import { render, staticRenderFns } from "./ExpulsionMac.vue?vue&type=template&id=4a088822&scoped=true"
import script from "./ExpulsionMac.vue?vue&type=script&lang=js"
export * from "./ExpulsionMac.vue?vue&type=script&lang=js"
import style0 from "./ExpulsionMac.vue?vue&type=style&index=0&id=4a088822&prod&lang=css"
import style1 from "./ExpulsionMac.vue?vue&type=style&index=1&id=4a088822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a088822",
  null
  
)

export default component.exports